import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import PasswordRequirement from '@tportal/login/components/PasswordRequirement';
import i18n from '@tportal/login/i18n';

interface Props {
  value: string | null,
  setIsValidPassword: (...args: boolean[]) => void;
}

const PasswordValidator = (props: Props) => {
  const {
    value,
    setIsValidPassword
  } = props;

  const [validLength, setValidLength] = useState<boolean>(false);
  const [hasLetter, setHasLetter] = useState<boolean>(false);
  const [hasNumber, setHasNumber] = useState<boolean>(false);
  const [hasSymbol, setHasSymbol] = useState<boolean>(false);

  const symbols = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

  useEffect(() => {
    if (value !== null) {
      setValidLength(value.length >= 8);
      setHasLetter(/[a-zA-Z]/.test(value));
      setHasNumber(/\d/.test(value));
      setHasSymbol(symbols.test(value));
    }
  }, [value]);

  useEffect(() => {
    setIsValidPassword((validLength && hasLetter && hasNumber && hasSymbol));
  }, [validLength, hasLetter, hasNumber, hasSymbol]);

  return (
    <div>
      <small>{i18n.t('messages.password_requirements.intro')}</small>
      <ul className='pl-3'>
        <PasswordRequirement
          isValid={validLength}
          value={value}
          requirement={i18n.t('messages.password_requirements.length')}
        />
        <PasswordRequirement
          isValid={hasLetter}
          value={value}
          requirement={i18n.t('messages.password_requirements.letter')}
        />
        <PasswordRequirement
          isValid={hasNumber}
          value={value}
          requirement={i18n.t('messages.password_requirements.number')}
        />
        <PasswordRequirement
          isValid={hasSymbol}
          value={value}
          requirement={i18n.t('messages.password_requirements.symbol')}
        />
      </ul>
    </div>
  );
};

export default observer(PasswordValidator);

